import { Highlight, themes } from "prism-react-renderer";
import { Card, CardBody, Col } from "reactstrap";
import { htmlData } from "../../../../Data/Miscellaneous/Editor";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import { HTMLModeTitle } from "../../../../Utils/Constants";

export default function HtmlMode() {
  return (
    <Col xl={6}>
      <Card>
        <CommonCardHeader title={HTMLModeTitle} />
        <CardBody>
          <Highlight theme={themes.vsDark} code={htmlData} language="HTML">
            {({ style, tokens, getLineProps, getTokenProps }) => (
              <pre style={style}>
                {tokens.map((line, i) => (
                  <div key={i} {...getLineProps({ line })}>
                    {line.map((token, key) => (
                      <span key={key} {...getTokenProps({ token })} />
                    ))}
                  </div>
                ))}
              </pre>
            )}
          </Highlight>
        </CardBody>
      </Card>
    </Col>
  );
}
